<template>
  <div class="search patriotism" @touchmove.prevent @mousewheel.prevent>
    <!-- 输入框 -->
    <div class="searchBox">
      <div class="content">
        <div class="patriotismTitle">
          <span class="title f14">排行榜</span>
        </div>

        <div class="input">
          <van-search
            clearable
            @clear="clear()"
            :left-icon="searchIcon"
            v-model="value"
            placeholder="请输入选手编号或名称"
          />
        </div>
        <div class="searchBtn">
          <van-button class="btn" @click="gotoVote()" type="primary"
          :style="{ 'background': info.setting.color }"
            >搜索</van-button
          >
        </div>
      </div>
    </div>
    <!-- 关闭按钮 -->
    <div class="close">
      <van-icon @click="close()" name="close" />
    </div>
  </div>
</template>

<script>
import searchMixin from "@/mixins/search.js";
export default {
  mixins: [searchMixin],
  data() {
    return {
      info: JSON.parse(sessionStorage.getItem("info")),
      searchIcon: require("@/assets/calligraphy/vote/SearchIcon.png"),
    };
  },
};
</script>

<style lang="less" scoped>
/deep/ input::placeholder {
  color: rgba(36, 48, 58, 0.5);
}

/deep/ .van-field__left-icon {
  display: grid;
  align-items: center;
  margin-right: .195rem !important;
}

/deep/ .van-field__control {
  color: rgba(36, 48, 58, 1) !important;
}

.search {
   width: 10rem;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  max-width: 10rem;
  margin: auto;
  z-index: 999999;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background: rgba(0, 0, 0, 0.5);
  .searchBox {
    width: 9.2rem;
    height: 5rem;
    box-sizing: border-box;
    position: relative;
    .content {
      width: 90.5%;
      background: rgba(252, 251, 243, 1);
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      position: absolute;
      bottom: .2666667rem;
      left: 0;
      right: 0;
      margin: auto;
      border-radius: .2rem;
      height: 4.7rem;
      .patriotismTitle {
        text-align: center;
        height: .907rem;
        display: flex;
        justify-content: center;
        align-items: center;
        background: url("@/assets/patriotism/vote/rulesTitle_back.png") no-repeat;
        background-size: 100% 100%;
        color: #fcfbf3;
        font-weight: 500;
        letter-spacing: 1px;
        margin-bottom: .85333rem;
        .title {
          position: relative;
        }
        .title::before {
          content: "";
          background: url("@/assets/patriotism/vote/left.png") no-repeat;
          left: -.7rem;
          top: 0;
          height: .32rem;
          width: .4rem;
          position: absolute;
          background-size: 100% 100%;
        }
        .title::after {
          content: "";
          background: url("@/assets/patriotism/vote/right.png") no-repeat;
          right: -.7rem;
          top: 0;
          height: .32rem;
          width: .4rem;
          position: absolute;
          background-size: 100% 100%;
        }
        .icon1 {
          transform: rotateY(180deg);
          padding: 0 .13333rem;
        }
        .icon2 {
          padding: 0 .13333rem;
        }
      }
      .input {
        padding: 0rem 2% 0rem;
        color: #444;
        box-sizing: border-box;
        background: #fff;
        background-size: 100% 100%;
        width: 92%;
        margin: auto;
        .van-search {
          background-size: 100% 100%;
          padding: 0;
          border-radius: 0.08rem;
          border: 1px solid #f9f9f9;
          border-radius: .5rem;
          .van-search__content {
            background: bottom;
          }
        }
        .van-search__action {
          width: 2.6666667rem;
          text-align: center;
          color: #fff;
          padding: 0;
          .searchBtn {
            color: #fff;
            position: relative;
            box-sizing: border-box;
            background: url("@/assets/calligraphy/btnBack.png") no-repeat;
            background-size: 100% 100%;
          }
        }
      }
      .searchBtn {
        height: .96rem;
        width: 100%;
        box-sizing: border-box;
        margin-top: .5rem;
        display: grid;
        justify-content: center;
        .btn {
          width: 2.71rem !important;
          height: .762rem !important;
          background: linear-gradient(180deg, #f0ae9e 0, #e94226 56.667941%, #efab7e 99.986342%) ;
        }
        .van-button {
          width: 100%;
          height: 100%;
          border: none;
        }
      }
    }
  }
  div.close {
    margin-top: .5333333rem;
    .van-icon-close {
      font-size: .96rem;
      color: #fff;
    }
  }
}
</style>